// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"207":"8e14f2e2","782":"2f74b893","972":"93cf2c9e"}[chunkId] + ".css";
};